import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const cartStore = {
  state: () => ({
    cartItems: [],
    pendingLoad: false
  }),
  getters: {
    countCartItems: state => {
      let result = 0;
      state.cartItems.forEach(function(element) {
        result += element.quantity;
      });
      return result;
    },
    getItemById: state => itemId => {
      let result = 0;
      state.cartItems.forEach(function(element) {
        if (element.id === itemId && element.type !== 5) {
          result += element.quantity;
        }
      });
      return result;
    },
    getItemByType: state => itemData => {
      let result = 0;
      state.cartItems.forEach(function(element) {
        if (element.id === itemData.id && element.type === itemData.type) {
          result = element.quantity;
        }
      });
      return result;
    }
  },
  mutations: {
    addCartItem(state, payload) {
      let found = false;
      let objectToAdd = {};
      switch (typeof payload) {
        case "number":
          objectToAdd = {
            id: payload,
            type: 1
          };
          break;
        case "string":
          objectToAdd = {
            id: parseInt(payload),
            type: 1
          };
          break;
        case "array":
          objectToAdd = {
            id: payload[0],
            type: payload[1]
          };
          break;
        case "object":
          objectToAdd = {
            id: payload.id,
            type: payload.type
          };
          break;
      }

      let quantity = 1;
      if (typeof payload === "object" && payload.quantity !== undefined) {
        quantity = payload.quantity;
      }

      state.cartItems.forEach(function(element) {
        if (
          element.id === objectToAdd.id &&
          element.type === objectToAdd.type
        ) {
          found = true;
          element.quantity += quantity;
        }
      });
      if (!found) {
        objectToAdd.quantity = quantity;
        state.cartItems.push(objectToAdd);
      }
    },
    removeCartItem(state, payload) {
      let itemIndex = -1;
      let objectToRemove = {};
      switch (typeof payload) {
        case "number":
          objectToRemove = {
            id: payload,
            type: 1
          };
          break;
        case "string":
          objectToRemove = {
            id: parseInt(payload),
            type: 1
          };
          break;
        case "array":
          objectToRemove = {
            id: payload[0],
            type: payload[1]
          };
          break;
        case "object":
          objectToRemove = {
            id: payload.id,
            type: payload.type
          };
          break;
      }

      let quantity = 1;
      if (typeof payload === "object" && payload.quantity !== undefined) {
        quantity = payload.quantity;
      }

      state.cartItems.forEach(function(element, index) {
        if (
          element.id === objectToRemove.id &&
          element.type === objectToRemove.type
        ) {
          element.quantity -= quantity;
          if (element.quantity === 0) {
            itemIndex = index;
          }
        }
      });
      if (itemIndex !== -1) {
        state.cartItems.splice(itemIndex, 1);
      }
    },
    clearCart(state)  {
      state.cartItems = [];
    },
    loadCart(state, payload) {
      state.cartItems = payload;
    },
    setPendigState(state, payload) {
      state.pendingLoad = payload
    }
  },
  actions: {
    addCartItem({ commit, dispatch }, payload) {
      commit("addCartItem", payload);
      dispatch("saveUserLists");
    },
    removeCartItem({ commit, dispatch }, payload) {
      commit("removeCartItem", payload);
      dispatch("saveUserLists");
    },
    clearCart({ commit, dispatch }) {
      commit("clearCart");
      dispatch("saveUserLists");
    }
  }
};

const favStore = {
  state: {
    favItems: []
  },
  getters: {
    countFavItems: state => {
      return state.favItems.length;
    },
    getFavItemById: state => itemId => {
      let result = 0;
      state.favItems.forEach(function(element) {
        if (element.id === itemId && element.type !== 5) {
          result = 1;
        }
      });
      return result;
    },
    getFavItemByType: state => itemData => {
      let result = 0;
      state.favItems.forEach(function(element) {
        if (element.id === itemData.id && element.type === itemData.type) {
          result = 1;
        }
      });
      return result;
    }
  },
  mutations: {
    addFavItem(state, payload) {
      let objectToAdd = {};
      switch (typeof payload) {
        case "number":
          objectToAdd = {
            id: payload,
            type: 1
          };
          break;
        case "string":
          objectToAdd = {
            id: parseInt(payload),
            type: 1
          };
          break;
        case "array":
          objectToAdd = {
            id: payload[0],
            type: payload[1]
          };
          break;
        case "object":
          objectToAdd = {
            id: payload.id,
            type: payload.type
          };
          break;
      }
      let esta = false;
      state.favItems.forEach((element) => {
        if (
          element.id === objectToAdd.id &&
          element.type === objectToAdd.type
        ){
          esta = true;
        }
      })
      if (!esta) {
        state.favItems.push(objectToAdd);
      }
    },
    removeFavItem(state, payload) {
      let objectToRemove = {};
      switch (typeof payload) {
        case "number":
          objectToRemove = {
            id: payload,
            type: 1
          };
          break;
        case "string":
          objectToRemove = {
            id: parseInt(payload),
            type: 1
          };
          break;
        case "array":
          objectToRemove = {
            id: payload[0],
            type: payload[1]
          };
          break;
        case "object":
          objectToRemove = {
            id: payload.id,
            type: payload.type
          };
          break;
      }
      let index = -1;
      state.favItems.forEach((element, eindex) => {
        if (
          element.id === objectToRemove.id &&
          element.type === objectToRemove.type
        ){
          index = eindex;
        }
      })
      if (index !== -1) {
        state.favItems.splice(index, 1);
      }
    },
    loadFavs(state, payload) {
      state.favItems = payload;
    }
  },
  actions: {
    addFavItem({ commit, dispatch }, payload) {
      commit("addFavItem", payload);
      dispatch("saveUserLists");
    },
    removeFavItem({ commit, dispatch }, payload) {
      commit("removeFavItem", payload);
      dispatch("saveUserLists");
    }
  }
};

const saveStore = {
  state: () => ({
    saveItems: []
  }),
  getters: {
    countSaveItems: state => {
      let result = 0;
      state.saveItems.forEach(function(element) {
        result += element.quantity;
      });
      return result;
    },
    getSaveItemById: state => itemId => {
      let result = 0;
      state.saveItems.forEach(function(element) {
        if (element.id === itemId) {
          result = element.quantity;
        }
      });
      return result;
    },
    getSaveItemByType: state => itemData => {
      let result = 0;
      state.saveItems.forEach(function(element) {
        if (element.id === itemData.id && element.type === itemData.type) {
          result = element.quantity;
        }
      });
      return result;
    }
  },
  mutations: {
    addSaveItem(state, payload) {
      let found = false;
      let objectToAdd = {};
      switch (typeof payload) {
        case "number":
          objectToAdd = {
            id: payload,
            type: 1
          };
          break;
        case "string":
          objectToAdd = {
            id: parseInt(payload),
            type: 1
          };
          break;
        case "array":
          objectToAdd = {
            id: payload[0],
            type: payload[1]
          };
          break;
        case "object":
          objectToAdd = {
            id: payload.id,
            type: payload.type
          };
          break;
      }

      let quantity = 1;
      if (typeof payload === "object" && payload.quantity !== undefined) {
        quantity = payload.quantity;
      }

      state.saveItems.forEach(function(element) {
        if (
          element.id === objectToAdd.id &&
          element.type === objectToAdd.type
        ) {
          found = true;
          element.quantity += quantity;
        }
      });
      if (!found) {
        objectToAdd.quantity = quantity;
        state.saveItems.push(objectToAdd);
      }
    },
    removeSaveItem(state, payload) {
      let itemIndex = -1;
      let objectToRemove = {};
      switch (typeof payload) {
        case "number":
          objectToRemove = {
            id: payload,
            type: 1
          };
          break;
        case "string":
          objectToRemove = {
            id: parseInt(payload),
            type: 1
          };
          break;
        case "array":
          objectToRemove = {
            id: payload[0],
            type: payload[1]
          };
          break;
        case "object":
          objectToRemove = {
            id: payload.id,
            type: payload.type
          };
          break;
      }

      let quantity = 1;
      if (typeof payload === "object" && payload.quantity !== undefined) {
        quantity = payload.quantity;
      }

      state.saveItems.forEach(function(element, index) {
        if (
          element.id === objectToRemove.id &&
          element.type === objectToRemove.type
        ) {
          element.quantity -= quantity;
          if (element.quantity === 0) {
            itemIndex = index;
          }
        }
      });
      if (itemIndex !== -1) {
        state.saveItems.splice(itemIndex, 1);
      }
    },
    loadSaves(state, payload) {
      state.saveItems = payload;
    }
  },
  actions: {
    addSaveItem({ commit, dispatch }, payload) {
      commit("addSaveItem", payload);
      dispatch("saveUserLists");
    },
    removeSaveItem({ commit, dispatch }, payload) {
      commit("removeSaveItem", payload);
      dispatch("saveUserLists");
    }
  }
};

const userStore = {
  state: {
    isLogged: false,
    name: "Nombre",
    lastname: "Apellido",
    usrid: 0,
    siteData: {}
  },
  getters: {
    getUsrFullname: state => {
      return state.name + " " + state.lastname;
    }
  },
  mutations: {
    setLogStatus(state, payload) {
      state.isLogged = payload;
    },
    setSiteData(state, payload) {
      state.siteData = payload;
    },
    setUserInfo(state, payload) {
      state.name = payload.name;
      state.lastname = payload.lastname;
      state.usrid = payload.id;
    }
  },
  actions: {
    Logout({ commit }) {
      localStorage.removeItem('clientId');
      commit("setLogStatus", false);
    },
    LogIn({ commit, state, dispatch, getters }, payload) {
      localStorage.clientId = payload.id;
      commit('setUserInfo', payload);
      commit("setLogStatus", true);
      commit('setPendigState', true);
      axios
          .post(
          state.siteData.location + "clients/clients/getUserStores",
          JSON.stringify({id: payload.id}),
          {
              validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
              },
              headers: {
              "Content-Type": "application/json"
              }
          }
          )
          .then(evtResponse => {
            console.log(evtResponse.data);
            if (evtResponse.data.records.length > 0) {
              if (evtResponse.data.records[0].cart) {
                JSON.parse(evtResponse.data.records[0].cart).forEach((element) => {
                  if (getters.getItemById(element.id) === 0) {
                    commit('addCartItem', element);
                  }
                });
              }
              if (evtResponse.data.records[0].saveitems) {
                JSON.parse(evtResponse.data.records[0].saveitems).forEach((element) => {
                  commit('addSaveItem', element);
                });
              }
              if (evtResponse.data.records[0].favs) {
                JSON.parse(evtResponse.data.records[0].favs).forEach((element) => {
                  commit('addFavItem', element);
                });
              }
            }
            commit('setPendigState', false);
            dispatch('saveUserLists');
          });
    },
    saveUserLists({ state, rootState  }) {
      if (state.isLogged) {
        axios
          .post(
            state.siteData.location + "clients/clients/updateLists",
            JSON.stringify({ id: state.usrid, cart: rootState.cart.cartItems, favs: rootState.favs.favItems, saves: rootState.saves.saveItems }),
            {
              validateStatus(status) {
                return status < 500; // Resolve only if the status code is less than 500
              },
              headers: {
                "Content-Type": "application/json"
              }
            }
          )
          .then(evtResponse => {
            console.log(evtResponse.data);
          });
      }
    }
  }
};

export default new Vuex.Store({
  modules: {
    cart: cartStore,
    favs: favStore,
    saves: saveStore,
    user: userStore
  }
});
